module.exports = __webpack_public_path__ + "img/tips2.104be512.png";